import { useState, useEffect } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, TextField, Button, Grid2, Alert, Dialog, Snackbar} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import imageCompression from "browser-image-compression";
import { Box, Fab } from "@mui/material";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";

function AdminBlog() {
    const [posts, setPosts] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null)
    const [expanded, setExpanded] = useState(false);
    const [formData, setFormData] = useState({
        id: "",
        titulo: "",
        text: "",
        foto: "",
        data: "",
    });
    const [showAddForm, setShowAddForm] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [successText, setSuccessText] = useState('');
    const [error, setError] = useState(false);
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const handleClickDialog = () => {
        setOpenDialog(true);
      }
    
      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setError(false);
        setOpenDialog(false);
        setOpen(false);
    };

    const handleExpanded = (id) => (event, isExpanded) => {
        setExpanded(isExpanded ? id : false);
    };

    const fetchPosts = async () => {
        try {
            const { data } = await axios.get("https://api.sigmasystems.com.br/api/odontoluzzi/get-posts");
            const sorted = [...data].sort((a, b) => new Date(b.data) - new Date(a.data));
            setPosts(sorted);
        } catch (err) {
            console.error("Erro ao carregar posts:", err);
        }
    }
    useEffect(() => {
        fetchPosts();
    },[]);

    const handleSelectCard = (post) => {
        if (showAddForm) {
        setShowAddForm(false)
        }
        if (selectedCard?.id === post.id) {
        handleCancel();
        } else {
        axios
            .get(
            `https://api.sigmasystems.com.br/api/odontoluzzi/get-posts?id=${post.id}`
            )
            .then((response) => {
            const data = response.data;
            if (data) {
                setSelectedCard(post);
                setFormData({
                id: data.id || "",
                titulo: data.titulo || "",
                text: data.text || "",
                foto: data.foto || "",
                fotoFile: null,
                fotoPreview: "",
                data_hora: data.data_hora || "",
                });
            }})
            .catch((error) => {
            console.error("Erro ao buscar especialidade:", error);
            });
        }
    };

    const handleSave = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('titulo', formData.titulo);
            formDataToSend.append('text', formData.text);
            if (formData.fotoFile) {
                formDataToSend.append("foto", formData.fotoFile);
            }

            await axios.post(`https://api.sigmasystems.com.br/api/odontoluzzi/update-post/${formData.id}`, formDataToSend,
                {headers: {
                    "Content-Type": "multipart/form-data",
                }}
            );
            setOpen(true);
            setSuccessText('Post alterado!')
            fetchPosts();
            handleCancel();
            setExpanded(false);
        } catch (err) {
            setError(true);
            setErrorText('Erro ao alterar Post.')
            console.error("Erro ao salvar", err);
        }
    }

      const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
      
        try {
          const options = {
            maxSizeMB: 1,          // máximo 1MB
            maxWidthOrHeight: 1280, // redimensiona se maior
            useWebWorker: true,    // otimiza com webworker
          };
      
          let compressedFile = file;
      
          if (file.size / 1024 / 1024 > 1) {
            compressedFile = await imageCompression(file, options);
          }
      
          const previewUrl = URL.createObjectURL(compressedFile);
      
          setFormData((prev) => ({
            ...prev,
            fotoFile: compressedFile,   // arquivo final (pronto pra enviar)
            fotoPreview: previewUrl,    // preview
          }));
        } catch (error) {
          console.error("Erro ao comprimir a imagem:", error);
        }
      };

    const handleChange = (field, value) => {
        setFormData((prev) => ({
          ...prev,
          [field]: value,
        }));
      };
    const handleCancel = () => {
        setSelectedCard(null);
        setExpanded(null);
        setFormData({id:"", titulo: "", text: "", foto: "", data_hora: "" });
        if(showAddForm) {
            setShowAddForm(false);
        }
    };
    const handleOpenAdd = () => {
        setSelectedCard(null);
        setExpanded(null);
        setShowAddForm(true);
        setFormData([])
        
      }
    const handleAdd = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('titulo', formData.titulo);
            formDataToSend.append('text', formData.text);
            if (formData.fotoFile) {
                formDataToSend.append("foto", formData.fotoFile);
            }
            if (!formData.titulo || !formData.text) {
                setError(true);
                setErrorText('Verifique os campos!');
                return error;
            }

            await axios.post(`https://api.sigmasystems.com.br/api/odontoluzzi/post-register`, formDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            setOpen(true);
            setSuccessText('Post realizada!');
            fetchPosts();
            handleCancel();
        } catch {
            setError(true);
            setErrorText('Erro ao cadastrar post!');
            console.error("Erro ao cadastrar post:", error);
        }
    }
    const handleExcluir = async () => {
        try {
            const post_id = formData.id;
            await axios.post('https://api.sigmasystems.com.br/api/odontoluzzi/remove-post',{id:post_id})
            setOpen(true);
            setSuccessText('Post Excluido!');
            setOpenDialog(false);
            handleCancel();
            fetchPosts();
        } catch (error) {
            setError(true);
            setErrorText('Falha ao excluir Postagem!');
            console.error('Falha ao excluir Postagem:', error);
        }
    }

    return(
        <div className="container">
            <div className="body" style={{ justifyItems: "center", width: "100%" }}>
                <div className="adminMenuContainer">
                    <div className="adminTitle">Blog</div>
                    <div
                        className="adminMenuContent"
                        style={{
                        maxWidth: "1280px",
                        height: "fit-content",
                        maxHeight:'700px',
                        borderRadius: "0px 0px 10px 10px",
                        }}
                    >
                        <Grid2 container spacing={2}>
                            <Grid2 item>
                                <Button
                                onClick={handleOpenAdd}
                                sx={{
                                    color: "#fff",
                                    height: 40,
                                    width: 162,
                                    borderRadius: "5px",
                                    fontSize: "18px",
                                    backgroundColor: "#B08E44",
                                    textTransform: "none",
                                    "&:hover": { color: "#fff", backgroundColor: "#041819" },
                                }}
                                >
                                + ADICIONAR
                                </Button>
                            </Grid2>
                        </Grid2>
                        {showAddForm && (
                        <div>
                            <div className="adminSubTitle">Imagem</div>
                            <Grid2 container spacing={2}>
                                <Grid2 item>
                                <img
                                    src={
                                    formData.fotoPreview
                                        ? formData.fotoPreview
                                        : "https://odontoluzzi.com.br/images/padrao/padraoServico.png"
                                    }
                                    alt="Nova Imagem"
                                    style={{
                                    width: "100%",
                                    maxWidth:'400px',
                                    height:'110px',
                                    borderRadius: "8px",
                                    objectFit:'cover'
                                    }}
                                />
                                </Grid2>
                                <Grid2 item>
                                <label className="btnUpload">
                                    <input
                                    style={{ display: "none" }}
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    />
                                    Escolher<br/>Foto
                                </label>
                                </Grid2>
                            </Grid2>
            
                            <div className="adminSubTitle">Título</div>
                            <TextField
                                fullWidth
                                variant="outlined"
                                value={formData.titulo}
                                onChange={(e) => handleChange("titulo", e.target.value)}
                            />
            
                            <div className="adminSubTitle">Texto</div>
                            <TextField
                                fullWidth
                                multiline
                                variant="outlined"
                                value={formData.text}
                                onChange={(e) => handleChange("text", e.target.value)}
                            />
                            <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                                <Grid2 item>
                                <Button
                                    variant="contained"
                                    sx={{
                                    backgroundColor: "#B08E44",
                                    "&:hover": { backgroundColor: "#041819" },
                                    }}
                                    onClick={handleAdd}
                                >
                                    Finalizar
                                </Button>
                                </Grid2>
                                <Grid2 item>
                                <Button
                                    variant="outlined"
                                    sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                                    onClick={handleCancel}
                                >
                                    Cancelar
                                </Button>
                                </Grid2>
                            </Grid2>
                        </div>)}
                        <div className="adminSubTitle">Lista de Postagens</div>                              

                        {posts.map((post) => (
                            <Accordion key={post.id} expanded={expanded === post.id} onChange={(event, isExpanded) => {
                                handleExpanded(post.id)(event, isExpanded); if (isExpanded){handleSelectCard(post)}}}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                    <Typography sx={{flexGrow:1}}>
                                        {post.titulo} - {new Date(post.data_hora).toLocaleString()}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div>
                                        <div className="adminSubTitle">Imagem</div>
                                        <Grid2 container spacing={2}>
                                            <Grid2 item>
                                            <img
                                                src={
                                                formData.fotoPreview
                                                    ? formData.fotoPreview
                                                    : formData.foto ? `https://api.sigmasystems.com.br/api/odontoluzzi/uploads/blog/${formData.foto}`
                                                    : "https://odontoluzzi.com.br/images/padrao/padraoServico.png"
                                                }
                                                alt={formData.titulo}
                                                style={{
                                                width: "100%",
                                                maxWidth:'400px',
                                                height:'110px',
                                                borderRadius: "8px",
                                                objectFit:'cover'
                                                }}
                                            />
                                            </Grid2>
                                            <Grid2 item>
                                            <label className="btnUpload">
                                                <input
                                                style={{ display: "none" }}
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                                />
                                                Trocar Foto
                                            </label>
                                            </Grid2>
                                        </Grid2>
                        
                                        <div className="adminSubTitle">Título</div>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            value={formData.titulo}
                                            onChange={(e) => handleChange("titulo", e.target.value)}
                                        />
                        
                                        <div className="adminSubTitle">Texto</div>
                                        <TextField
                                            fullWidth
                                            multiline
                                            variant="outlined"
                                            value={formData.text}
                                            onChange={(e) => handleChange("text", e.target.value)}
                                        />                     
                                        <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
                                            <Grid2 item>
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                    backgroundColor: "#B08E44",
                                                    "&:hover": { backgroundColor: "#041819" },
                                                    }}
                                                    onClick={handleSave}
                                                >
                                                    Finalizar
                                                </Button>
                                            </Grid2>
                                            <Grid2 item>
                                                <Button
                                                    variant="outlined"
                                                    sx={{ border: "2px solid #B08E44", color: "#B08E44" }}
                                                    onClick={handleCancel}
                                                >
                                                    Cancelar
                                                </Button>
                                            </Grid2>
                                            <Grid2 item>
                                                <Button
                                                onClick={handleClickDialog}
                                                sx={{
                                                    color: "#B08E44",
                                                    height: 40,
                                                    width: 162,
                                                    borderRadius: "5px",
                                                    fontSize: "18px",
                                                    backgroundColor: "none",
                                                    border: expanded ? "solid 2px #B08E44" : 'solid 2px #cfcfcf',
                                                    "&:hover": { color: "#fff", backgroundColor: "#041819" },
                                                }}
                                                >
                                                EXCLUIR
                                                </Button>
                                            </Grid2>
                                        </Grid2>
                                        </div>
                                </AccordionDetails>
                            </Accordion>
                        ))}                        
                    </div>
                </div>
            </div>
            <Box
                sx={{
                "& > :not(style)": { m: 1 },
                position: "absolute",
                bottom: 16,
                right: 16,
                }}
            >
                <Fab
                onClick={() => window.history.back()}
                variant="extended"
                sx={{
                    backgroundColor: "#B08E44",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#041819" },
                }}
                >
                <ReplyRoundedIcon sx={{ mr: 1 }} /> Voltar
                </Fab>
            </Box>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
                <Alert
                onClose={handleClose}
                severity="success"
                variant="filled"
                sx={{ width: '100%' }}
                >
                {successText}
                </Alert>
            </Snackbar>
            <Snackbar open={error} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'bottom',horizontal:'right'}}>
                <Alert
                onClose={handleClose}
                severity="error"
                variant="filled"
                sx={{ width: '100%' }}
                >
                {errorText}
                </Alert>
            </Snackbar>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {"Tem certeza que deseja excluir o serviço?"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {formData.name}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={handleExcluir} autoFocus>
                    EXCLUIR
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default AdminBlog;